var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.data.split('\n')),function(param,index){return (param)?_c('li',{key:index},[_c('b',[_vm._v(_vm._s(param.split(';')[0]))]),_vm._v(": "+_vm._s(param.split(';')[1])+" "),(param.split(';')[2])?_c('span',[_vm._v("("+_vm._s(param.split(';')[2])+")")]):_vm._e()]):_vm._e()}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }